import {
    CERTIFICATE_CATEGORY,
    CERTIFICATE_MAILING_ADDRESS,
    LOCAL_ADDRESS,
    OVERSEAS_ADDRESS,
    CERTIFICATE_OWNER_PARTICULARS,
    CERTIFICATE_INFORMATION,
    OPERATOR_EXAM_DETAILS,
    BOOKLET,
    SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyLicence/SSOCLicence';

import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';

import { formatDateTo_ddMMyyyy } from 'utils/application.helpers';

export const formatSSOC = async (licenceDetails: any, caseTypeID: string, application?: string) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;
    let booklet = [];

    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    if (licenceDetails && licenceDetails.BookletEntryList && licenceDetails.BookletEntryList.length > 0) {
        booklet = licenceDetails?.BookletEntryList.map((value: Record<string, string>, i: number) => ({
            'booklet-serial-number': value?.BookletSerialNumber ?? '-',
            'booklet-type': value?.BookletType ?? '-',
            'booklet-remarks': value?.BookletRemarks ?? '-',
            'issue-date': formatDateTo_ddMMyyyy(value?.BookletIssueDate) ?? '-',
            'booklet-expiry-date': formatDateTo_ddMMyyyy(value?.BookletExpiryDate) ?? '-',
            'certificate-no': value?.certificateNumber ?? '-',
            'owner-name': value?.ownerName ?? '-',
            'certificate-issue-date': formatDateTo_ddMMyyyy(value?.LicenceIssueDateLatest) ?? '-',
            'expiry-date': formatDateTo_ddMMyyyy(value?.BookletExpiryDate) ?? '-',
            'date-of-birth': formatDateTo_ddMMyyyy(value?.dateOfBirth) ?? '-',
            'place-of-birth': value?.placeOfBirth ?? '-',
            'id-number': value?.IDNo ?? '-',
            'cdc-no': value?.cdcNo ?? '-',
            age: value?.Age ?? '-',
            height: value?.heightCm ?? '-',
            'colour-of-eyes': value?.colourOfEyes ?? '-',
            'colour-of-hair': value?.colourOfHair ?? '-',
            complexion: value?.complexion ?? '-',
            'visible-peculiarities': value?.visiblePeculiarities ?? '-'
        }));
    }

    licence = {
        id: 'ship-station-operator-certificate',
        formID: 'ship-station-operator-certificate',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
        values: {
            [`${CERTIFICATE_CATEGORY}-please-select-the-certification-you-want-to-apply`]:
                licenceDetails?.certificateCategory?.pleaseSelectTheCertificateYouWishToApply ?? '-',

            [`${CERTIFICATE_MAILING_ADDRESS}-collection-method`]: licenceDetails?.certificateMailingAddress?.collectionMethod ?? '-',
            [`${CERTIFICATE_MAILING_ADDRESS}-same-as-billing-address`]:
                licenceDetails?.certificateMailingAddress?.sameAsBillingAddress ?? '-',

            [`${LOCAL_ADDRESS}-building-name`]: licenceDetails?.certificateMailingAddress?.localAddress?.buildingName ?? '-',
            [`${LOCAL_ADDRESS}-postal-code`]: licenceDetails?.certificateMailingAddress?.localAddress?.postalCode ?? '-',
            [`${LOCAL_ADDRESS}-street-name`]: licenceDetails?.certificateMailingAddress?.localAddress?.streetName ?? '-',
            [`${LOCAL_ADDRESS}-block-house-no`]: licenceDetails?.certificateMailingAddress?.localAddress?.blockNo ?? '-',
            [`${LOCAL_ADDRESS}-floor-level`]: licenceDetails?.certificateMailingAddress?.localAddress?.floor ?? '-',
            [`${LOCAL_ADDRESS}-unit`]: licenceDetails?.certificateMailingAddress?.localAddress?.unit ?? '-',

            [`${OVERSEAS_ADDRESS}-foreign-address-line-one`]: licenceDetails?.certificateMailingAddress?.foreignAddressLine1 ?? '-',
            [`${OVERSEAS_ADDRESS}-foreign-address-line-two`]: licenceDetails?.certificateMailingAddress?.foreignAddressLine2 ?? '-',
            [`${OVERSEAS_ADDRESS}-foreign-address-line-three`]: licenceDetails?.certificateMailingAddress?.foreignAddressLine3 ?? '-',
            [`${OVERSEAS_ADDRESS}-city`]: licenceDetails?.certificateMailingAddress?.city ?? '-',
            [`${OVERSEAS_ADDRESS}-state`]: licenceDetails?.certificateMailingAddress?.state ?? '-',
            [`${OVERSEAS_ADDRESS}-zip-code`]: licenceDetails?.certificateMailingAddress?.zipCode ?? '-',
            [`${OVERSEAS_ADDRESS}-country`]: licenceDetails?.certificateMailingAddress?.country ?? '-',

            [`${CERTIFICATE_OWNER_PARTICULARS}-owner-name`]: licenceDetails?.certificateSOwnerParticulars?.ownerName ?? '-',
            [`${CERTIFICATE_OWNER_PARTICULARS}-sex`]: licenceDetails?.certificateSOwnerParticulars?.Sex ?? '-',
            [`${CERTIFICATE_OWNER_PARTICULARS}-date-of-birth`]:
                formatDateTo_ddMMyyyy(licenceDetails?.certificateSOwnerParticulars?.dateOfBirth) ?? '-',
            [`${CERTIFICATE_OWNER_PARTICULARS}-id-type`]: licenceDetails?.certificateSOwnerParticulars?.idTypeIdNumber?.idType ?? '-',
            [`${CERTIFICATE_OWNER_PARTICULARS}-nationality`]: licenceDetails?.certificateSOwnerParticulars?.nationality ?? '-',
            [`${CERTIFICATE_OWNER_PARTICULARS}-place-of-birth`]: licenceDetails?.certificateSOwnerParticulars?.placeOfBirth ?? '-',
            [`${CERTIFICATE_OWNER_PARTICULARS}-height`]: licenceDetails?.certificateSOwnerParticulars?.heightCm ?? '-',
            [`${CERTIFICATE_OWNER_PARTICULARS}-colour-of-eyes`]: licenceDetails?.certificateSOwnerParticulars?.colourOfEyes ?? '-',
            [`${CERTIFICATE_OWNER_PARTICULARS}-colour-of-hair`]: licenceDetails?.certificateSOwnerParticulars?.colourOfHair ?? '-',
            [`${CERTIFICATE_OWNER_PARTICULARS}-complexion`]: licenceDetails?.certificateSOwnerParticulars?.complexion ?? '-',
            [`${CERTIFICATE_OWNER_PARTICULARS}-visible-peculiarities`]:
                licenceDetails?.certificateSOwnerParticulars?.visiblePeculiarities ?? '-',
            [`${CERTIFICATE_OWNER_PARTICULARS}-medical-certificate-issue-date`]:
                formatDateTo_ddMMyyyy(licenceDetails?.certificateInformation?.medicalCertificateIssueDate) ?? '-',
            [`${CERTIFICATE_OWNER_PARTICULARS}-medical-certificate-expiry-date`]:
                formatDateTo_ddMMyyyy(licenceDetails?.certificateInformation?.medicalCertificateExpiryDate) ?? '-',
            [`${CERTIFICATE_OWNER_PARTICULARS}-details-of-dispensations`]: licenceDetails?.certificateSOwnerParticulars?.cdcNo ?? '-',
            [`${CERTIFICATE_OWNER_PARTICULARS}-cdc-no`]: licenceDetails?.certificateSOwnerParticulars?.cdcNo ?? '-',

            [`${CERTIFICATE_INFORMATION}-certificate-no`]: licenceDetails?.certificateInformation?.certificateNumber ?? '-',
            [`${CERTIFICATE_INFORMATION}-issue-date`]: formatDateTo_ddMMyyyy(licenceDetails?.certificateInformation?.issueDate) ?? '-',
            [`${CERTIFICATE_INFORMATION}-capacity`]: licenceDetails?.certificateInformation?.Capacity ?? '-',
            [`${CERTIFICATE_INFORMATION}-function`]: licenceDetails?.certificateInformation?.Function ?? '-',
            [`${CERTIFICATE_INFORMATION}-level-of-responsibility`]: licenceDetails?.certificateInformation?.LevelOfResponsibility ?? '-',
            [`${CERTIFICATE_INFORMATION}-stcw-competency-standard`]: licenceDetails?.certificateInformation?.STCWCompetency ?? '-',
            [`${CERTIFICATE_INFORMATION}-limitations`]: licenceDetails?.certificateInformation?.Limitations ?? '-',
            [`${CERTIFICATE_INFORMATION}-endorsement`]: licenceDetails?.certificateInformation?.Endorsement ?? '-',

            [`${OPERATOR_EXAM_DETAILS}-operator-exam-certificate-class`]:
                licenceDetails?.OperatorExamDetails?.OperatorExamCertificateClass ?? '-',
            [`${OPERATOR_EXAM_DETAILS}-operator-exam-certificate-no`]: licenceDetails?.OperatorExamDetails?.OperatorExamCertficateNo ?? '-',
            [`${OPERATOR_EXAM_DETAILS}-operator-exam-certificate-date`]:
                formatDateTo_ddMMyyyy(licenceDetails?.OperatorExamDetails?.OperatorExamcertficateDate) ?? '-',
            [`${OPERATOR_EXAM_DETAILS}-place-of-exam`]: licenceDetails?.OperatorExamDetails?.PlaceofExam ?? '-',

            [`${BOOKLET}-list`]: booklet ?? [...booklet],

            [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
        }
    };

    return licence;
};

const ssocPayload = {
    formatSSOC
};

export default ssocPayload;
